import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54178041"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "artwork-search-form"
}
const _hoisted_2 = ["placeholder", "aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showSearchInput)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("input", {
          type: "search",
          placeholder: _ctx.$t('landing-page.search-all-works'),
          "aria-label": _ctx.$t('landing-page.search-all-works')
        }, null, 8, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          "aria-label": _ctx.$t('general.search')
        }, _hoisted_5, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}